const state = (function() {
    const BUILDER_STATE = {
        width: '',
        strapMaterial: '',
        strapColor: '',
        strapLength: '',
        strapVariantId: null,
        strapSku: '',
        strapName: '',
        strapPrice: 0,
        // 双层
        isDouble: false,
        innerStrapMaterial: '',
        innerStrapColor: '',
        innerStrapVariantId: null,
        innerStrapSku: '',
        innerStrapName: '',
        innerStrapPrice: 0,
        outerEmboss: '',
        innerEmboss: '',
        // 扣头
        buckleType: '',
        buckleMaterial: '',
        buckleColor: '',
        buckleWidth: '',
        buckleTechnology: '',
        // 扣头安装方式（Sewing / Screws）
        buckleInstallation: '',
        buckleVariantId: null,
        buckleSku: '',
        buckleName: '',
        bucklePrice: 0,
        buckleMaterialFilter: '',
        strapThickness: '',
        end: '',
        endPrice: 0,
        stitch: '',
        stitchPrice: 0,
        emboss: '',
        embossPrice: 0,
        craftFee: 30
    };

    const WIDTH_MAPPING = {
        '20mm': { strap: ['20mm'], buckle: ['20mm'] },
        '24mm': { strap: ['24mm'], buckle: ['24mm'] },
        '29mm': { strap: ['29mm'], buckle: ['29mm'] },
        '34mm': { strap: ['34mm'], buckle: ['34mm'] },
        '38mm': { strap: ['38mm'], buckle: ['38mm'] },
        '40mm': { strap: ['40mm'], buckle: ['40mm'] }
    };

    const listeners = [];

    function getState() {
        return { ...BUILDER_STATE };
    }

    function setState(key, value) {
        if (BUILDER_STATE.hasOwnProperty(key)) {
            BUILDER_STATE[key] = value;
            
            if (key === 'width') {
                handleWidthChange(value);
            }
            
            notifyListeners();
        }
    }

    function setMultiple(updates) {
        let needsNotify = false;
        
        Object.keys(updates).forEach(key => {
            if (BUILDER_STATE.hasOwnProperty(key)) {
                BUILDER_STATE[key] = updates[key];
                needsNotify = true;
                
                if (key === 'width') {
                    handleWidthChange(updates[key]);
                }
            }
        });
        
        if (needsNotify) {
            notifyListeners();
        }
    }

    function handleWidthChange(width) {
        const mapping = WIDTH_MAPPING[width];
        if (mapping) {
            BUILDER_STATE.strapWidths = mapping.strap;
            BUILDER_STATE.buckleWidths = mapping.buckle;
        } else {
            BUILDER_STATE.strapWidths = [];
            BUILDER_STATE.buckleWidths = [];
        }
        
        if (BUILDER_STATE.strapVariantId) {
            const straps = api.isCached('straps') ? api._cache.straps : [];
            const currentStrap = straps.find(s => s.id === BUILDER_STATE.strapVariantId);
            if (currentStrap && !BUILDER_STATE.strapWidths.includes(currentStrap.metafields.strap_width)) {
                BUILDER_STATE.strapVariantId = null;
                BUILDER_STATE.strapSku = '';
                BUILDER_STATE.strapName = '';
                BUILDER_STATE.strapPrice = 0;
            }
        }
        
        if (BUILDER_STATE.buckleVariantId) {
            const buckles = api.isCached('buckles') ? api._cache.buckles : [];
            const currentBuckle = buckles.find(b => b.id === BUILDER_STATE.buckleVariantId);
            if (currentBuckle && !BUILDER_STATE.buckleWidths.includes(currentBuckle.metafields.buckle_width)) {
                BUILDER_STATE.buckleVariantId = null;
                BUILDER_STATE.buckleSku = '';
                BUILDER_STATE.buckleName = '';
                BUILDER_STATE.bucklePrice = 0;
            }
        }
    }

    function subscribe(callback) {
        listeners.push(callback);
        return () => {
            const index = listeners.indexOf(callback);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    }

    function notifyListeners() {
        listeners.forEach(callback => {
            try {
                callback(getState());
            } catch (error) {
                console.error('State listener error:', error);
            }
        });
    }

    function resetState() {
        Object.keys(BUILDER_STATE).forEach(key => {
            if (key === 'craftFee') {
                BUILDER_STATE[key] = 30;
            } else {
                BUILDER_STATE[key] = '';
            }
        });
        BUILDER_STATE.strapPrice = 0;
        BUILDER_STATE.bucklePrice = 0;
        BUILDER_STATE.endPrice = 0;
        BUILDER_STATE.stitchPrice = 0;
        BUILDER_STATE.embossPrice = 0;
        notifyListeners();
    }

    function getStrapWidths() {
        return BUILDER_STATE.strapWidths || [];
    }

    function getBuckleWidths() {
        return BUILDER_STATE.buckleWidths || [];
    }

    function isValidWidthMapping(beltWidth, strapWidth, buckleWidth) {
        const mapping = WIDTH_MAPPING[beltWidth];
        if (!mapping) return false;
        return mapping.strap.includes(strapWidth) && mapping.buckle.includes(buckleWidth);
    }

    return {
        getState,
        setState,
        setMultiple,
        subscribe,
        resetState,
        getStrapWidths,
        getBuckleWidths,
        isValidWidthMapping
    };
})();